import React from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";

import { stringToHslColor } from "../../tools";

const onlineColor = "#44b700";
const offlineColor = "#fff";

function ClientAvatar({ initials, alias, isOffline }) {
  const color = isOffline ? offlineColor : onlineColor;
  const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
      //backgroundColor: '#44b700',
      //color: '#44b700',
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      backgroundColor: "#fff",
      color: "#fff",
      "&::after": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        //animation: 'ripple 1.2s infinite ease-in-out',
        //border: '1px solid currentColor',
        border: `2.4px solid ${color}`,
        content: '""',
      },
    },
    /*'@keyframes ripple': {
      '0%': {
        transform: 'scale(.8)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(2.4)',
        opacity: 0,
      },
    },*/
  }));

  return (
    <StyledBadge
      variant="dot"
      overlap="circular"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Avatar
        style={{
          color: "#fff",
          backgroundColor: stringToHslColor(alias),
          fontSize: initials?.length < 3 ? 20 : 16, // smaller fontSize for 3 initial characters
        }}
      >
        {initials === "" ? null : initials}
      </Avatar>
    </StyledBadge>
  );
}

ClientAvatar.propTypes = {
  alias: PropTypes.string.isRequired,
  isOffline: PropTypes.bool.isRequired,
};

export default ClientAvatar;
